import { AnimationBaseController, GameApiBase, ISpriteEvent } from "../../../modules/@denishussar/html5-game-engine";
import { Inject } from "../../../modules/@denishussar/html5-game-engine";
import { IAnimationControllerConfiguration } from "../../../modules/@denishussar/html5-game-engine";
import { GameModel } from "../../Models/GameModel";
import { Key, SoundType } from "../../../modules/@denishussar/html5-game-engine";
import { SoundConstants, SoundLevels } from "../../Constants/SoundConstants";



export interface IButtonControllerOptions {
    label?: string;
    onClick: (event?: ISpriteEvent) => void;
    hotKey: string;
    nonInteractive?: boolean;
    textPosition?: "top" | "middle" | "bottom"
}

export class ButtonController extends AnimationBaseController {
    $model: GameModel;
    private _pointerDown: boolean = false;
    private _pointerOver: boolean = false;
    private _pressed: boolean = false;
    private _enabled: boolean = true;

    public selected = false;

    public constructor(@Inject private _options: IButtonControllerOptions,
        @Inject private _arenaApi: GameApiBase) {
        super("ButtonController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        let keyboard = null;

        if (this._options.hotKey) {
            keyboard = {
                [Key[this._options.hotKey]]: {
                    pressed: () => {
                        if (!this._enabled) {
                            return;
                        }
                        this._pressed = true;
                        this.gotoAndStop("down");
                    },
                    released: () => {
                        if (!this._enabled || !this._pressed) {
                            return;
                        }
                        this._pressed = false;
                        this.gotoAndStop("up");
                        this._options.onClick();
                    },
                    down: () => {
                    },
                }
            }
        }

        return <IAnimationControllerConfiguration>{
            childControllers: {
            },
            onPointerDown: () => {
                if (!this._enabled) {
                    return;
                }
                this._pointerDown = true;
                this.gotoAndStop("down");
            },
            onPointerOut: () => {
                if (!this._enabled) {
                    return;
                }
                if (!this._pointerDown) {
                    this.gotoAndStop(this.selected ? "down" : "up");
                }
                this._pointerOver = false;
            },
            onPointerOver: () => {
                if (!this._enabled) {
                    return;
                }
                if (this._pointerDown) {
                    this.gotoAndStop("down");
                }
                else {
                    this.gotoAndStop(this.selected ? "down" : "over");
                }
                this._pointerOver = true;
                // this.soundManager.play(SoundConstants.BUTTON_ROLLOVER);
            },
            onPointerUp: () => {
                if (!this._enabled) {
                    this.gotoAndStop("up");
                    return;
                }
                this._pointerDown = false;
                if (this._pointerOver) {
                    this.gotoAndStop(this.selected ? "down" : "over");
                }
                else {
                    this.gotoAndStop(this.selected ? "down" : "up");
                }
            },
            onPointerUpOutside: () => {
                if (!this._enabled) {
                    return;
                }
                this.gotoAndStop(this.selected ? "down" : "up");
                this._pointerDown = false;
            },
            onTap: () => {
                const enabled = this._enabled
                if (!enabled) {
                    this.soundManager.playSound(SoundConstants.BUTTON_DISABLED, 0, SoundLevels.uiAction);
                    return;
                }
                this._options.onClick();

                // если логика в колбеке задизейблила кнопку,
                // для пользователя она была включена в момент нажатия.
                // Проигрываем звук обычной кнопки
                // play the button sound if the one was disabled by game logic and it was turned on for user
                if (enabled) {
                    this.soundManager.playSound(SoundConstants.BUTTON_CLICK, 0, SoundLevels.uiAction);
                }
            },
            sounds: [
                {
                    id: SoundConstants.BUTTON_DISABLED,
                    type: SoundType.SFX
                },
                {
                    id: SoundConstants.BUTTON_CLICK,
                    type: SoundType.SFX
                }
            ],
            keyboard: keyboard
        };
    }

    public toggle(select: boolean) {
        this.selected = select;
        this.gotoAndStop(this.selected ? "down" : "up");
    }

    public disabled() {
        this.gotoAndStop("disabled");
        this._enabled = false;
        this._pressed = false;
        this._pointerDown = false;
    }

    public enabled() {
        this._enabled = true;
        this.gotoAndStop("up");
    }

    protected onInitialize(): void {



        const label = this._options.label?.toString()?.toUpperCase() || '';
        this.setTextByQuery('button_text', label);
        if (this._options.textPosition) {
            this.setTextVerticalAlignByQuery('button_text', this._options.textPosition)
        }
        if (this._options.nonInteractive) {
            this.display.interactive = !this._options.nonInteractive;
        }
    }

}

